import React, { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { mergeRegister } from '@lexical/utils';
import { BLUR_COMMAND, COMMAND_PRIORITY_LOW, FOCUS_COMMAND } from 'lexical';

type Props = {
    onFocus?: () => void;
    onBlur?: () => void;
};
const FocusPlugin: React.FC<Props> = React.memo(function FocusPlugin({ onFocus, onBlur }) {
    const [editor] = useLexicalComposerContext();
    useEffect(() => {
        if (!editor) {
            return;
        }
        return mergeRegister(
            editor.registerCommand(
                BLUR_COMMAND,
                () => {
                    onBlur && onBlur();
                    return false;
                },
                COMMAND_PRIORITY_LOW,
            ),
            editor.registerCommand(
                FOCUS_COMMAND,
                () => {
                    onFocus && onFocus();
                    return false;
                },
                COMMAND_PRIORITY_LOW,
            ),
        );
    }, [editor, onBlur, onFocus]);

    return null;
});

export default FocusPlugin;
